import css from 'styled-jsx/css';

const styles = css.global`#santander-blog {
    padding: 32px 0 60px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%), #222;
}

#santander-blog .santander-blog-contain {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

#santander-blog .santander-blog-title {
    color: #FFF;
    font-family: "SantanderHeadline";
    font-size: 40px;
    font-style: normal;
    font-weight: 400;
    line-height: 60px;
    margin: 0;
}

#santander-blog .santander-blog-subtitle {
    color: #FFF;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
}

#santander-blog .santander-blog-link {
    color: #FFF;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
}

#santander-blog .cards-blog {
    display: flex;
    flex-direction: column;
    gap: 32px;
}

#santander-blog .card-blog {
    border-radius: 4px;
    border: 1px solid #767676;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 369px;
    padding-bottom: 15px;
}

#santander-blog .card-blog .card-blog-img {
    object-fit: cover;
    width: 100%;
    height: 189px;
    border-radius: 4px;
}

#santander-blog .card-blog .card-blog-text {
    color: #FFF;
    font-family: "SantanderHeadline";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px;
    padding: 15px 15px 0;
    flex: 1;
}

#santander-blog .card-blog .card-blog-link {
    color: #FFF;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    padding: 0 15px;
    margin-top: 40px;
    display: inline-block;
}

@media (min-width: 800px) {
    #santander-blog {
        padding: 32px 0 116px;
    }
    #santander-blog .cards-blog {
        flex-direction: row;
    }
}`;

export default styles;